module.exports = __webpack_public_path__ + "70361e1254e4b745504afbe206618673.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile10.png
// module id = 1870
// module chunks = 0